      <div class="d-flex justify-content-between align-items-center mb-3 mt-2 px-4 pt-3 pb-3">
        <!-- <h2 class="mb-0 semi-black" style="font-family: 'Rubik', serif;" *ngIf="!formCommentVisible">Comentarios</h2> -->
        <h2 class="mb-0 semi-black" style="font-family: 'Rubik', serif;" *ngIf="formCommentVisible">Crear comentario</h2>
        <!-- <div class="d-flex " style="gap: 1em;">
          <button type="button"
                 *ngIf="!createCommentsVisible && commentsAgentsUpdateValid()"
                 class="btn rounded btn-block btn-big font-poppins"
                 style="width: fit-content; border: 1px solid #b2b2b2;"
                 (click)="editComments()">{{ editCommentsVisible ? 'Lista comentarios' :  'Editar comentario'}}
         </button>
         <button type="button"
                 *ngIf="!editCommentsVisible && commentsAgentsCreateValid()"
                 class="btn rounded btn-block btn-big font-poppins"
                 style="width: fit-content; border: 1px solid #b2b2b2;"
                 (click)="addComments()">{{formCommentVisible ? 'Lista comentarios' :  ' Crear comentario '}}
         </button>
        </div> -->
      </div>

      <div *ngIf="!formCommentVisible" class="header-no-comments">

      </div>

<!-- FORMULARIO -->
      <ng-container *ngIf="formCommentVisible">
        <form [formGroup]="commentsForm" (ngSubmit)="onSubmitComment()" class="d-flex flex-column mt-3 mb-5 px-4" >

          <div class="d-flex mb-5">
            <div class="form-group align-items-center m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
              <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 24px; font-weight: 600;">{{'Agente: ' + agentName}}</p>
           </div>

           <div class="form-group align-items-center m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
            <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 24px; font-weight: 600;">{{'Agencia: ' + agencyName}}</p>
           </div>
          </div>

           <div class="d-flex mb-4">
            <div class="d-flex flex-column form-group m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
              <label for="" class="ml-2" style="font-family: 'Rubik', serif; font-weight: 500;font-size: 14px;">Califica tu experiencia</label>
              <div class="d-flex align-items-center">

                <rating
                       formControlName="assesment"
                       [max]="5"
                       [readonly]="false"
                       [customTemplate]="customTemplate">
                </rating>

               <ng-template
                 #customTemplate
                 let-fill="fill"
                 let-index="index">
                 <div class="position-relative d-inline-block" style="width: 52px; height: 52px;">

                   <span #icon
                         class="icon-background"
                         style="width: 45px; height: 45px; border-radius: 50%; position: absolute; top: 3.5px; left: 3.5px; z-index: 1;">
                   </span>

                   <img

                     [src]="getIconsComments(index)"
                     style="width: 52px; height: 52px; position: relative; z-index: 2;"
                     alt="">

                 </div>
               </ng-template>

               <p class="mb-0 ml-3" style="font-weight: 600;">
                 {{getCommentadjective(commentsForm.get('assesment').value)}}
               </p>
              </div>
                <span *ngIf="commentsForm.get('assesment')?.touched && (commentsForm.get('assesment')?.invalid || commentsForm.get('assesment')?.value === 0)">
                  <p class="mb-0 ml-2" style="font-size: 12px;font-weight: 600; color: red; position: absolute;left: 0; bottom: -20px;">Califique su experiencia</p>
                 </span>
           </div>

           <div class="d-flex flex-column form-group  m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
            <label for="" class="ml-2"  style="font-family: 'Rubik', serif; font-weight: 500;font-size: 14px;">Título comentario</label>
              <input type="text"
                 name="agencia"
                 class="form-control input-search-box"
                 style="background-color: white;"
                 formControlName="title"
                 placeholder="Ej: Buena estadía"
                 >


                 <span *ngIf="commentsForm.get('title')?.touched && commentsForm.get('title')?.invalid">
                  <p class="mb-0 ml-2" style="font-size: 12px;font-weight: 600; color: red; position: absolute;left: 0; bottom: -20px;">Ingresar título</p>
                 </span>
           </div>

          </div>

          <div class="d-flex mb-4">


           <div class="d-flex flex-column form-group  m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
            <label for="" class="ml-2"  style="font-family: 'Rubik', serif; font-weight: 500;font-size: 14px;">Nombre pasajero</label>
              <input type="text"
                 name="agencia"
                 class="form-control input-search-box"
                 style="background-color: white;"
                 formControlName="passenger_name"
                 placeholder="Nombre pasajero"
                 >


                 <span *ngIf="commentsForm.get('title')?.touched && commentsForm.get('title')?.invalid">
                  <p class="mb-0 ml-2" style="font-size: 12px;font-weight: 600; color: red; position: absolute;left: 0; bottom: -20px;">Ingresar título</p>
                 </span>
           </div>

            <div class="d-flex flex-column form-group  m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
            <label for="" class="ml-2"  style="font-family: 'Rubik', serif; font-weight: 500;font-size: 14px;">Fecha reserva</label>
              <input
              #reservation_date
              formControlName="reservation_date"
              type="text"
              class="form-control input-search-box"
              style="background-color: white;"
              id="reservation_date"
              placeholder="Fecha de reserva"
              autocomplete="off"
              bsDatepicker
              [bsConfig]="dpConfig"
              (onShown)="fixCalendarPosition()"
              readonly
              [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': backgroundAssent},
                          ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': backgroundAssent}}"
              />
            </div>
          </div>

            <div class="d-flex flex-column mb-4 form-group m-0 py-0 px-1 col-lg-12 col-xg-12 col-md-12 col-sm-12 scroll position-relative">
              <label for="" class="ml-2" style="font-family: 'Rubik', serif; font-weight: 500;font-size: 14px;">Comentario</label>
              <textarea formControlName="comments"
              class="form-control"
              name="comments"
              rows="5"
              placeholder="Ej: @Recepción, el traslado llegó tarde. El cuarto estaba limpio pero sin toallas. Recordar pedir GPS en el alquiler de auto.">
            </textarea>
            <span *ngIf="commentsForm.get('comments')?.touched && commentsForm.get('comments')?.invalid">
                  <p class="mb-0 ml-2" style="font-size: 12px; font-weight: 600;color: red; position: absolute;left: 0; bottom: -20px;">Ingresar comentario</p>
                 </span>
            </div>

            <div class="d-flex align-items-start mb-4 py-4 px-3 form-group m-0 py-0 px-1 col-lg-12 col-xg-12 col-md-12 col-sm-12 scroll position-relative" style="gap: .75em; border: 1px solid #ececec; border-radius: 6px;"
            [ngStyle]="{'background-color': backgroundAssent}">

              <input type="checkbox"  style="transform: scale(1.2);margin-top: 1px;cursor: pointer" formControlName="assent">
              <p class="mb-0" style="font-size: 13px; font-weight: 600;line-height: 1.2;">Certifico que esta opinión refleja mi propia experiencia y mi opinión sincera sobre este establecimiento. No tengo ninguna relación personal ni comercial con el mismo, ni recibí incentivos o pagos por escribir esta reseña. Doy mi consentimiento para su publicación bajo estos términos.</p>

            </div>

            <div class="d-flex justify-content-end">
              <button type="submit" class="btn btn-continue">Guardar</button>
            </div>
        </form>

      </ng-container>

      <!-- LISTADO -->

  <ng-container *ngIf="!formCommentVisible">
   <ng-container *ngIf="comments && comments.length > 0">
    <ng-container *ngFor="let comment of comments">
      <div class="container-list-comments">
        <div class="info-user-comment">
          <p class="mb-0 rubik-semibold-13pt name_user">{{comment.booking_agent_name}}</p>
          <p class="mb-0 rubik-regular-12pt date_comment">{{comment.created_at | date : 'dd-MMM-yyyy'}}</p>
          <div class="container-icons" >
            <ng-container *ngFor="let element of assesmentComments; let i = index; let last = last">
              <div class="row-icon" [ngStyle]="getStyleContainerIcons(i, comment?.assesment)">
                <img [src]="getIconsComments(element)" class="img-logo" alt="">
              </div>
            </ng-container>
          </div>
        </div>
        <div class="container-comment">
          <p class="mb-0 rubik-regular-12pt" 
             [ngClass]="{ 'texto-recortado': !textComplete }">{{comment.comments}} 
              <span (click)="toggleTextComplete()" 
                    *ngIf="comment.comments.length > 200" 
                    [ngStyle]="{'color': clientSettingBody?.card_line}">Ver Mas
              </span>
          </p>
        </div>
      </div>
    </ng-container>
  </ng-container>


  <ng-container *ngIf="comments && comments.length === 0">
    <div  class="col-xg-12 col-lg-12 col-md-12 col-xs-12 photos-modal-hotel"  style="border-radius: 6px; padding: 0px;border:1px solid #ccc;background-color: #fff">
      <div class="d-flex justify-content-center align-items-center" style="height: 450px;">
        <p class="semiblack" style="font-family: 'Rubik', serif;font-size: 28px;font-weight: 600;">No hay comentarios para este producto</p>
      </div>
    </div>
  </ng-container>

</ng-container>
